import { GetTermsUseUseCase } from '@/core/domain/terms-use/usecases/getTermsUse.usecase';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'fe-terms-use',
    templateUrl: './terms-use.component.html',
    styleUrls: ['./terms-use.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TermsUseComponent implements OnInit {
    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
        {
            label: 'fe_breadcrumb_view_questions',
            url: 'questions',
        },
        {
            label: 'fe_breadcrumb_view_terms_use',
            url: 'questions/terms-of-use',
        },
    ];

    constructor(private readonly getTermsUseUseCase: GetTermsUseUseCase) {}

    public termsUseContent = '';

    public ngOnInit(): void {
        this.getTermsUseUseCase
            .execute()
            .pipe(
                switchMap((response) => {
                    this.termsUseContent = response.data.termsUse;
                    return of(response);
                }),
            )
            .subscribe();
    }
}
